module.exports = __webpack_public_path__ + "img/optional-step-2.867affbb.png";